import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormulaireCoordonneesBancaires } from 'src/app/models/formulaire/formulaire-coordonnees-bancaires.model';

@Injectable({ providedIn: 'root' })
export class FormulaireBancaireService {
  formGroup: FormGroup<FormulaireCoordonneesBancaires> | null = null;

  setForm(form: FormGroup<FormulaireCoordonneesBancaires>) {
    this.formGroup = form;
  }

  getForm(): FormGroup<FormulaireCoordonneesBancaires> | null {
    return this.formGroup;
  }
}
